import React, { createContext, useContext } from "react";
import MobileNavbarModern from "./MobileNavbarModern";
import FooterMenuModern from "./FooterMenuModern";
import "../assets/mobile-modern.sass";

const MobileLayoutContext = createContext(false);

const MobileLayoutModern = ({
  children,
  isAuthScreen = false,
  hideFooter = false,
  noMainPadding = false,
}) => {
  const isNestedLayout = useContext(MobileLayoutContext);

  if (isNestedLayout) {
    return <>{children}</>;
  }

  const rootClass = `mobile-layout-modern${isAuthScreen ? ' auth-lock' : ''}`;

  const mainClass = [
    'mobile-main',
    isAuthScreen && 'auth-screen',
    hideFooter && 'no-footer',
    noMainPadding && 'no-main-padding',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <MobileLayoutContext.Provider value={true}>
      <div className={rootClass}>
        <MobileNavbarModern />
        <main className={mainClass}>
          {children}
        </main>
        {!hideFooter && <FooterMenuModern />}
      </div>
    </MobileLayoutContext.Provider>
  );
};

export default MobileLayoutModern; 
